/*
 * @Author: liyxt
 * @Date: 2020-04-07 11:41:26
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-05 14:25:46
 * @Description: file content
 */ 
/**
 * @desc 判断下拉框是否有值
 * @param value
 * @return true -> 有值 false -> 无值
 */
export function hasValue(value) {
	let dataType = Object.prototype.toString.call(value);
	if (dataType === '[object Array]') {
		return value.length > 0;
	}

	if (dataType === '[object Object]') {
		return value.key && value.label;
	}

	if (dataType === '[object String]') {
		return value !== '';
	}
}

export function hasBackSpaceClear(props) {
	let { required, showClear } = props;
	//不是必填项，并显示清空按钮时添加backspace快捷键功能
	return required !== true && showClear === true;
}
